<template>
    <button class="button button--secondary-contrast button--small" @click="goToGoogleTranslate">
        <svg-icon name="google_translate" class="button__icon" />{{ $t('common.get_the_translation') }}
    </button>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null,
        },
    },
    computed: {
        googleTranslateLink() {
            return `https://translate.google.com/?sl=auto&tl=${this.$i18n.locale}&text=${encodeURIComponent(
                this.text
            )}`;
        },
    },
    methods: {
        goToGoogleTranslate() {
            window.open(this.googleTranslateLink, '_blank', 'noopener,noreferrer');
        },
    },
};
</script>

<style></style>
